const War = require('../../entities/War');
const { Age } = require('../../Constants/Constants');
const WarNames = require("../Names/WarNames");

class WarOverTechnology extends War {
    constructor()
    {
        super(
            Age.Age2,
            WarNames.WarOverTechnology,
            "The victor takes science equal to the military advantage from the defeated civilization. Special technologies can be stolen instead equal to their cost.",
            2,
            {}
        )
    }
}

module.exports = WarOverTechnology;